import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google-plus-g': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M386.1 228.5c1.8 9.7 3.1 19.4 3.1 32 0 109.8-73.6 187.5-184.4 187.5-106.1 0-192-85.9-192-192s85.9-192 192-192c51.9 0 95.1 18.9 128.6 50.3l-52.1 50c-14.1-13.6-39-29.6-76.5-29.6-65.5 0-118.9 54.2-118.9 121.3s53.4 121.3 118.9 121.3c76 0 104.5-54.7 109-82.8h-109v-66h181.3v0zM571.5 234.9h55.7v56h-55.7v55.7h-56v-55.7h-55.7v-56h55.7v-55.7h56v55.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/google-plus-g.js
// module id = null
// module chunks = 